module.exports = __webpack_public_path__ + "media/images/emoticons/maple-0b29fa235ece96139c5f9bb24291ca37.gif";